var global = require('../internals/global');

module.exports = global.Promise;



//////////////////
// WEBPACK FOOTER
// ./~/canvg/~/core-js/internals/native-promise-constructor.js
// module id = 994
// module chunks = 0